/* Livraison estimée datée (Vanille Désiré)
   Calcule une fenêtre de livraison en jours ouvrés, fuseau Europe/Paris.
   Texte FR en dur : aucune clé de traduction disponible dans le thème. */

if (!customElements.get('vd-delivery-estimate')) {
  customElements.define(
    'vd-delivery-estimate',
    class VdDeliveryEstimate extends HTMLElement {
      connectedCallback() {
        try {
          this.render();
        } catch (error) {
          // En cas d'échec (Intl indisponible…), le bloc reste simplement masqué.
          console.error('[vd-delivery-estimate]', error);
        }
      }

      /* Date « vue de Paris », quel que soit le fuseau du visiteur. */
      parisNow() {
        return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Paris' }));
      }

      isWeekend(date) {
        const day = date.getDay();
        return day === 0 || day === 6;
      }

      addBusinessDays(date, days) {
        const result = new Date(date);
        let remaining = days;
        while (remaining > 0) {
          result.setDate(result.getDate() + 1);
          if (!this.isWeekend(result)) remaining -= 1;
        }
        return result;
      }

      render() {
        const cutoffHour = parseInt(this.dataset.cutoffHour || '13', 10);
        const minDays = parseInt(this.dataset.minDays || '2', 10);
        const maxDays = parseInt(this.dataset.maxDays || '4', 10);

        const now = this.parisNow();
        const shipDate = new Date(now);
        let shipsToday = true;

        if (now.getHours() >= cutoffHour || this.isWeekend(now)) {
          shipsToday = false;
          do {
            shipDate.setDate(shipDate.getDate() + 1);
          } while (this.isWeekend(shipDate));
        }

        const from = this.addBusinessDays(shipDate, minDays);
        const to = this.addBusinessDays(shipDate, maxDays);

        const formatter = new Intl.DateTimeFormat('fr-FR', {
          weekday: 'short',
          day: 'numeric',
          month: 'long',
        });

        const window = `livraison estimée entre le ${formatter.format(from)} et le ${formatter.format(to)}`;
        const text = shipsToday
          ? `Commandez avant ${cutoffHour} h : expédition aujourd'hui, ${window}.`
          : `Expédition le prochain jour ouvré : ${window}.`;

        const target = this.querySelector('[data-vd-estimate-text]');
        if (!target) return;
        target.textContent = text;
        this.hidden = false;
      }
    }
  );
}
